// extracted by mini-css-extract-plugin
module.exports = {"h4":"LiveEvent_h4__3Fisi","btn":"LiveEvent_btn__pJCZ9","spacing":"LiveEvent_spacing__URKNB","arrow":"LiveEvent_arrow__hWSo1"};